import {GIFT_CARD_CODE_LENGTH} from '@/constants';
import {getMessage} from './i18n.utils';
import {formatNumber} from './giftCard.utils';
import {NodeLikeError, SerializedError} from '@/types/error.types';
import {isError} from '@epic-mw/error-types';

type DataKey = 'faqAccountBalance' | 'maxAmount' | 'locale' | (string & {});

/** I don't like how this is, could be done better */
export const mapClientError = (
	messages: Record<string, string>,
	error: string,
	data?: Partial<Record<DataKey, string | number>>
) => {
	switch (error) {
		case 'epic.app.error.reach_wallet_top_up_limit': {
			return getMessage(messages, error, [
				data?.faqAccountBalance || 'https://www.epicgames.com/site/account-balance-faq'
			]);
		}
		case 'epic.app.error.addFunds.maxAmount': {
			return getMessage(messages, error, [data?.maxAmount || 0]); // pre-formatted number
		}
		case 'errors.com.epicgames.validation.min_length':
		case 'errors.com.epicgames.validation.min_length': {
			return getMessage(messages, error, [
				formatNumber(GIFT_CARD_CODE_LENGTH, String(data?.locale || ''))
			]);
		}
		default: {
			return messages[error] || error || '';
		}
	}
};

export function isNodeLikeError(value: unknown): value is NodeLikeError {
	return isError(value);
}

export function serializeError(e: unknown, depth = 0): SerializedError {
	// prevent infinite recursion on circular causes
	if (depth > 3) return {value: e};

	if (!isNodeLikeError(e)) return {value: e};

	const out: SerializedError = {
		name: e.name,
		message: e.message,
		stack: e.stack,
		code: e.code,
		errno: e.errno,
		syscall: e.syscall,
		address: e.address,
		port: e.port
	};

	if ('cause' in e && e.cause != null) {
		out.cause = isError(e.cause) ? serializeError(e.cause, depth + 1) : e.cause;
	}

	return out;
}
